import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit, OnInit, ViewChild
} from '@angular/core';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable as MatTable, MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { DataService } from '../../services/data.service';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

@Component({
  selector: 'app-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss'],
  standalone: false
})
export class SummaryTableComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() data: any;
  @Input() type: any;
  @Input() paramNameList: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: any;
  subscriptions: any;

  constructor(private dataServ: DataService,) {
    this.subscriptions = dataServ.events.subscribe(this.checkAndReplot());
    this.checkAndReplot();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.checkAndReplot();
  }

  ngAfterViewInit(): void {
    this.checkAndReplot();
  }

  formatMetric(value: any, digits: number): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return '';
    }
    return numericValue.toFixed(digits);
  }

  checkAndReplot() {
    if (this.data && this.data.length) {
      if (this.type === 'process') {
        this.displayedColumns = ['parametername', 'lsl', 'targetvalue', 'usl', 'mean', 'stddev', 'pp', 'ppk'];
      } else {
        this.displayedColumns = ['parametername', 'lsl', 'targetvalue', 'usl', 'totalDataPoints', 'targetPacked', 'actualPacked', 'giveAway', 'giveAwayPercentage', 'lslRejectPercentage'];
      }
      this.data.forEach((e, i) => {
        if (e.kpi != undefined) {
          if (this.type === 'process') {
            this.data[i].usl = e.kpi.usl;
            this.data[i].targetvalue = e.kpi.targetValue;
            this.data[i].lsl = e.kpi.lsl;
            this.data[i].mean = e.kpi.avg;
            this.data[i].stddev = e.kpi.sigmaval;
            this.data[i].pp = e.kpi.xcp;
            this.data[i].ppk = e.kpi.xcpk;
          } else {
            this.data[i].usl = e.kpi.usl;
            this.data[i].targetvalue = e.kpi.targetValue;
            this.data[i].lsl = e.kpi.lsl;
            this.data[i].totalDataPoints = e.kpi.totalDataPoints;
            this.data[i].targetPacked = e.kpi.targetPacked;
            this.data[i].actualPacked = e.kpi.actualPacked;
            this.data[i].giveAway = e.kpi.giveAway;
            this.data[i].giveAwayPercentage = e.kpi.giveAwayPercentage;
            this.data[i].lslRejectPercentage = e.kpi.lslRejectPercentage;
          }
        }
      });
      let newData = [];
      newData = this.data.filter(item => item.kpi != undefined);
      this.dataSource.data = newData;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      if (this.table) {
        this.table.dataSource = this.dataSource;
      }
    }
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }


}
